

  export default {
    name: 'TextImageTwoColumns',

    props: {
        title: {
            type: String,
            default: "",
        },
        description: {
            type: String,
            default: "",
        },
        imageObj: {
            type: Object,
            default: () => {},
        },
        mode: {
            type: String,
            default: 'text-image',
        }
    },

    data() {
      return {
        modeAvailable: ['text-image', 'image-text'],
      }
    },
  }
